import Emitter from './emitter';

export default class Receiver extends Emitter {
    constructor(opts = {}) {
        super();

        this.multiple = opts.multipleReceivers;
    }
    on(ev, ...args) {
        !this.multiple && this.listenerCount(ev) && this.removeAllListeners(ev);
        super.on(ev, ...args);
    }
    destroy() {
        this.removeAllListeners();
    }
}
